<template>
  <div class="view-active-campaign">
    <div class="breadcrumbs d-flex align-items-center font-weight-bold mb-9">
      <router-link :to="{ name: 'home' }" class="text-secondary">
        Início
      </router-link>
      <i class="icon-angle-right text-secondary mx-3"></i>
      <router-link :to="{ name: 'tools' }" class="text-secondary">
        Ferramentas
      </router-link>
      <i class="icon-angle-right text-secondary mx-3"></i>
      <router-link
        :to="{ name: 'tools-email-marketing' }"
        class="text-secondary"
      >
        E-mail marketing
      </router-link>
      <i class="icon-angle-right text-secondary mx-3"></i>
      RD Station Marketing
    </div>

    <h6 class="d-none d-lg-block">RD Station</h6>
    <div class="row align-items-center mb-5 pt-6">
      <div class="col-lg-3 mb-3">
        <div class="d-flex align-items-center">
          <div class="mr-5">Contas</div>
          <button
            class="btn btn-sm btn-outline-primary btn-square-sm p-5"
            @click="refresh"
          >
            <i class="icon-refresh-ccw" />
          </button>
        </div>
      </div>
      <div class="col-lg-9">
        <div class="d-flex algn-items-center justify-content-end">
          <search-filter
            class="mr-3 flex-fill"
            placeholder="Pesquisar conta"
            @search="searching"
            :showFilters="false"
            :showResultsDropdown="false"
          />
          <button
            type="button"
            class="btn btn-primary px-5 px-lg-6"
            @click="modal = true"
          >
            <span class="d-none d-lg-inline">
              Adicionar
            </span>
            <i class="icon-plus d-lg-none lead"></i>
          </button>
        </div>
      </div>
    </div>
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>
    <div v-else>
      <div
        v-if="!integrationList.length"
        class="container centralize-row text-center pt-5"
      >
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <img
              class="d-block mb-9 mx-auto"
              src="@/assets/images/home/welcome.svg"
            />
            <h5>Você ainda não adicionou nenhuma conta</h5>
            <div class="text-secondary mb-5">
              Clique no botão acima para cadastrar
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <data-table
          class="d-none d-lg-block"
          :columns="columns"
          :data="integrationList"
          :columnsFr="'2fr 2fr 1fr 1fr 0.4fr'"
        >
          <template #default="{ item }">
            <small class="d-flex align-items-center">
              {{ item.client_id }}
            </small>
            <small class="d-flex align-items-center">
              {{ item.client_secret }}
            </small>
            <small
              class="d-flex align-items-center font-weight-bold"
              :class="item.status == 'active' ? 'text-success' : 'text-danger'"
            >
              {{ item.status == "active" ? "Ativo" : "Inativo" }}
            </small>
            <small
              class="d-flex align-items-center font-weight-bold"
              :class="
                item.integration_status == 'connected'
                  ? 'text-success'
                  : 'text-danger'
              "
            >
              {{
                item.integration_status == "connected"
                  ? "Conectada"
                  : "Desconectada"
              }}
            </small>

            <div class="d-flex align-items-center justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="getActions(item)"
                @delete="submitDelete(item)"
                @authorize="authorize(item)"
                @change-status="changeStatus(item)"
              />
            </div>
          </template>
        </data-table>
        <!-- mobile area -->
        <data-table
          class="d-lg-none"
          :columns="columns.slice(0, 2).map(() => '')"
          :data="integrationList"
          :firstColumnFr="3"
          :lastColumnFr="0.5"
        >
          <template #default="{ item }">
            <div class="d-flex flex-column text-left pl-3 py-5">
              <small class="d-flex align-items-center">
                <strong class="mr-3">
                  Client ID:
                </strong>
                {{ item.client_id }}
              </small>
              <small class="d-flex align-items-center">
                <strong class="mr-3">
                  Client secret:
                </strong>
                {{ item.client_secret }}
              </small>
              <small
                class="d-flex align-items-center font-weight-bold text-success"
              >
                <strong class="mr-3 text-dark">
                  Status:
                </strong>
                {{ item.status == "active" ? "Ativo" : "Inativo" }}
              </small>
            </div>
            <div class="d-flex justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="getActions(item)"
                @delete="submitDelete(item)"
                @authorize="authorize(item)"
                @change-status="changeStatus(item)"
              />
            </div>
          </template>
        </data-table>
        <!-- mobile area -->
      </div>
      <div v-if="integrationList.length" class="d-flex justify-content-center">
        <paginator :pagination="pagination" @on-update="dispatch" />
      </div>
    </div>
    <RDStationModal v-model="modal" @refresh="refresh" />
  </div>
</template>
<script>
import RDStationModal from "@/components/tools/modals/RDStation";
import { mapState } from "vuex";

export default {
  components: {
    RDStationModal
  },
  data() {
    return {
      loading: false,
      modal: false,
      product_id: null,
      search: "",
      columns: [
        "Client ID",
        "Client secret",
        "Status",
        "Status da integração",
        ""
      ],
      actions: [
        {
          text: "Excluir",
          class: "text-danger",
          icon: "icon-trash",
          confirmation: {
            enable: true,
            text:
              "Deseja mesmo excluir esta integração? Não enviaremos mais os leads para esta segmentação."
          },
          event: "delete"
        }
      ]
    };
  },
  mounted() {
    this.$store.commit("integration/setIntegration", "rd-station");
    this.dispatch();
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("integration", ["integrationList", "pagination"])
  },
  methods: {
    getActions(item) {
      const actions = [...this.actions];
      actions.unshift({
        class: item.status == "active" ? "text-danger" : "text-success",
        text: item.status == "active" ? "Desativar" : "Ativar",
        icon: "fa-regular fa-power-off",
        event: "change-status",
        confirmation: { enable: false }
      });
      if (item.integration_status == "disconnected")
        actions.unshift({
          class: "text-success",
          text: "Autorizar aplicativo",
          icon: "fa-solid fa-check",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "authorize"
        });
      return actions;
    },
    authorize(item) {
      window.open(item.url);
    },
    dispatch() {
      let params = { search: this.search };

      this.loading = true;
      this.$store
        .dispatch("integration/getIntegration", params)
        .catch(error => {
          this.$message.error("Não foi possível carregar as contas integradas");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searching(v) {
      this.search = v;
      this.dispatch();
    },
    submitDelete(v) {
      this.loading = true;
      this.$store
        .dispatch("integration/deleteProvider", v.id)
        .then(() => {
          this.dispatch();
          this.$message.success("Integração removida");
        })
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.$message.error(error.response.data.detail);
          } else {
            this.$message.error("Não foi possível deletar a conta integrada");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeStatus(item) {
      this.$store
        .dispatch("integration/putIntegration", {
          id: item.id,
          status: item.status == "active" ? "inactive" : "active"
        })
        .then(this.refresh)
        .catch(() => this.$message.error("Não foi possível alterar o status"));
    },
    refresh() {
      this.dispatch();
    }
  }
};
</script>
